import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const inlineCode = (theme: Theme) =>
  css({
    backgroundColor: theme.system.backgroundMutedHover,
    color: theme.text.body,
    borderRadius: "0.25rem",
    padding: "0 0.25rem",
    display: "inline-flex",
    fontSize: typography.sizeSmall,
  });
